
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { MigrationSiteModel } from './Distribution.Api.Models.Migration.MigrationSite';
import { Model, ModelProperty } from 'models/Model';


export class MigrationSourceModel extends Model<MigrationSourceModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'migrationSource.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'migrationSource.property.name' },
		{ name: 'ip', type: 'string', languageString: 'migrationSource.property.ip' },
		{ name: 'login', type: 'string', languageString: 'migrationSource.property.login' },
		{ name: 'created', type: 'Date', languageString: 'migrationSource.property.created', isHidden: true },
		{ name: 'sites', type: 'MigrationSiteModel[]', languageString: 'migrationSource.property.sites', isHidden: true, isArray: true, isObject: true, new: () => { return new MigrationSiteModel }, properties: () => { return MigrationSiteModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public ip: string;
	public login: string;
	public created?: Date;
	public sites: MigrationSiteModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.ip = '';
		this.login = '';
		this.created = undefined;
		this.sites = [];
		
	}
	getProperties(){
		return MigrationSourceModel.classProperties;
	}
}

